var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 165.822C32 146.855 47.3458 131.479 66.2758 131.479H306.207C325.137 131.479 340.482 146.855 340.482 165.822V363.298C340.482 382.266 325.137 397.642 306.207 397.642H172.219H144.175H116.132H66.2758C47.3458 397.642 32 382.266 32 363.298V165.822Z",
    fill: "#D1D3D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M163.411 125.719C163.411 91.6771 180.717 68 216.076 68L425.631 68C457.502 68 480.23 93.4795 480.23 125.199V291.075C481.27 331.114 452.671 339.434 423.031 340.474H307.689H278.994H249.875H221.276C186.593 340.474 163.411 321.755 163.411 285.355L163.411 125.719Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.161 468.251V364.232H211.299L116.901 473.781C111.811 479.688 102.161 476.067 102.161 468.251Z",
    fill: "#D1D3D4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M424.07 401.382V311.89L309.673 310.835L393.391 412.233C402.751 423.153 421.99 427.832 424.07 401.382Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M426.969 72.4541H216.886C172.068 72.4541 167.865 107.161 167.866 127.986V130.748V287.639C167.866 326.511 199.605 336.229 216.886 336.229H335.933L398.958 412.585C406.845 420.471 419.966 416.017 419.966 402.096V336.229C470.386 336.229 475.989 311.333 475.989 294.58V127.986C475.989 83.5604 443.309 72.4541 426.969 72.4541Z",
    stroke: "#97999B",
    strokeWidth: 8,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeDasharray: "24 18"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M321.551 172.683C323.147 172.683 324.44 173.976 324.44 175.572V205.43H354.298C355.894 205.43 357.188 206.724 357.188 208.32C357.188 209.915 355.894 211.209 354.298 211.209H324.44V241.067C324.44 242.663 323.147 243.957 321.551 243.957C319.955 243.957 318.662 242.663 318.662 241.067V211.209H288.804C287.208 211.209 285.914 209.915 285.914 208.32C285.914 206.724 287.208 205.43 288.804 205.43H318.662V175.572C318.662 173.976 319.955 172.683 321.551 172.683Z",
    fill: "#97999B",
    stroke: "#97999B",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoComment);
export default __webpack_public_path__ + "static/media/No_comment.cce5ac66a2f39463bcb9e1da89f60847.svg";
export { ForwardRef as ReactComponent };